export const DOI_LINK = "https://doi.org/";
